import { render, staticRenderFns } from "./workFlow.vue?vue&type=template&id=a126c10e&scoped=true"
import script from "./workFlow.vue?vue&type=script&lang=js"
export * from "./workFlow.vue?vue&type=script&lang=js"
import style0 from "./workFlow.vue?vue&type=style&index=0&id=a126c10e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a126c10e",
  null
  
)

export default component.exports